export { default as ProductThumb } from './ProductThumb';
export type { ProductThumbProps } from './ProductThumb';
